<template>
    <div
        class="sticky bg-gold-400 bg-opacity-75 z-200"
    >
        <div class="max-w-screen-xl mx-auto py-3 px-3">
            <div class="text-center px-4 tablet:px-16">
                <p class="font-medium text-white">
                    <span v-html="banner.message" />
                    <a
                        v-if="banner.link"
                        :href="banner.link"
                        class="text-white font-bold underline cursor-pointer whitespace-nowrap group transition-transform"
                        target="_blank">
                        {{ banner.linkText }} <span class="inline-block font-bold transition-transform transform duration-200 group-hover:translate-x-1">&rarr;</span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

</style>
